export default __webpack_public_path__ + "static/media/vista-master-plan.d4da77b7.pdf";